import { render, staticRenderFns } from "./VaultController.vue?vue&type=template&id=37695500&"
import script from "./VaultController.vue?vue&type=script&lang=ts&"
export * from "./VaultController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports